import React, { useEffect, useState } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { upsellOptions } from './data/copy';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { Bullets } from './components/Bullets';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { StickyCta } from './components/StickyCta';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
export function App() {
  const [selectedUpsell, setSelectedUpsell] = useState(upsellOptions[0]);
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-abyss font-body text-bone" data-id="element-0" data-mp="28sbad0uf2z52">
      <TopBar selectedUpsell={selectedUpsell} data-id="element-1" data-mp="23u9vyt7xrnzx" />
      <Hero selectedUpsell={selectedUpsell} data-id="element-2" data-mp="23ti6m04xmmi3" />
      <main data-id="element-3" data-mp="3iiweonbohg2p">
        <SocialProof data-id="element-4" data-mp="3ij61y35c994p" />
        <Problem data-id="element-5" data-mp="3ihv2gfixenje" />
        <Offer selectedUpsell={selectedUpsell} onSelectUpsell={setSelectedUpsell} data-id="element-6" data-mp="3mljat0fdtn5p" />
        <Solution data-id="element-7" data-mp="3mjg8pi0yg3km" />
        <Bullets data-id="element-8" data-mp="3rc9hqi3ghy2i" />
        <Guarantee selectedUpsell={selectedUpsell} data-id="element-9" data-mp="3rbrcivytg9ig" />
        <Faq data-id="element-10" data-mp="3recdzjv7cnfo" />
      </main>
      <Footer data-id="element-11" data-mp="5osn3wyp084" />
      <StickyCta selectedUpsell={selectedUpsell} data-id="element-12" data-mp="6hpnd64cbd2" />
      <FloatingWhatsApp data-id="element-13" data-mp="56qxrrj5tst" />
    </div>;
}